goog.provide("shadow.js.shim.module$src$svg$artwork$legacy_svg$default");
shadow.js.shim.module$src$svg$artwork$legacy_svg$default = shadow.js.shim.module$src$svg$artwork$legacy_svg.default;
